/* eslint-disable */
export default {
  inAMeeting: '会议中',
  onMyWay: '在路上',
  callMeBackIn: '请在以下时间后再打给我...',
  willCallYouBackIn: '将在以下时间后回电给您...',
  hour: '小时',
  min: '分钟',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
